export enum TradeTypeEnum {
  None,
  Ask,
  Bid
}